import request from '@/utils/request'
// 售后数量
export function afterSaleCount(data){
  return request({
    url:'/aftersale/count',
    method:'post',
    data:data
  })
}
// 需求
export function requirementCount(data){
  return request({
    url:'/requirement/countBy',
    method:'post',
    data:data
  })
}



// WEBPACK FOOTER //
// ./src/api/countNum.js